import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferOffer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { ERR_CAN_XFER_OFF, SUC_CAN_XFER_OFF } from '../../../../utils/strings';

export const useCancelTransferOffer = () => {
  const { submit } = useExerciseSubmission(
    TransferOffer.TransferOffer_Cancel,
    SUC_CAN_XFER_OFF,
    ERR_CAN_XFER_OFF,
  );
  return submit;
};
